import React from 'react';
import Header from '../components/layout/header';
import Unlockedlevel from '../components/common/unlockedlevel';
import pic9 from '../assets/pic9.png'
import pic11 from '../assets/pic11.png'
import './story.css'
import pic17 from '../assets/pic17.png'
import pic18 from '../assets/pic18.png'
import Photocontainer from '../components/common/photocontainer';
import { Link } from 'react-router-dom';
import PrimaryctaLong from '../components/common/primary cta long';
import pic19 from '../assets/pic19.png'
import pic20 from '../assets/pic20.png'
import pic21 from '../assets/pic21.png'
import pic22 from '../assets/pic22.png'
import Story1 from '../audio/Story1.mp3'
import Story2 from '../audio/story2.mp3'
import Story3 from '../audio/Story3.mp3'
import { useEffect } from 'react';
import { useRef } from 'react';
import AudioContext from '../components/common/AudioContext'; 
import Settings from '../components/common/settings';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';

const Story = () => {
const [settingsOpen, setSettingsOpen] = useState(false);
// const timersRef = useRef([]);
// const settingsOpenRef = useRef(false);
    const audio1Ref = useRef(null);
    const audio2Ref = useRef(null);
    const audio3Ref = useRef(null);
      const { soundVolume } = React.useContext(AudioContext);
       const location = useLocation();
  const comingBack = location.state?.back === true;
  const currentAudioRef = useRef(1);
  const audioDelayRef = useRef(null);



useEffect(() => {
    const audio = audio1Ref.current;

    if (audio) {
        audio.volume = soundVolume;
        currentAudioRef.current = 1;
        audio.play().catch(() => {});
    }
}, []);

useEffect(() => {
    [audio1Ref, audio2Ref, audio3Ref].forEach(ref => {
        if (ref.current) {
            ref.current.volume = soundVolume;
        }
    });
}, [soundVolume]);


useEffect(() => {
    const audios = {
        1: audio1Ref.current,
        2: audio2Ref.current,
        3: audio3Ref.current,
    };

    
if (settingsOpen) {
    clearTimeout(audioDelayRef.current);

    Object.values(audios).forEach(audio => audio?.pause());
} else {
    const currentAudio = audios[currentAudioRef.current];

    if (currentAudio && !currentAudio.ended) {
        currentAudio.play().catch(() => {});
    }
}
}, [settingsOpen]);


useEffect(() => {
    return () => {
        clearTimeout(audioDelayRef.current);
    };
}, []);


    return ( 
        <section className='container-levels-page'>
              {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
                <audio
                    ref={audio1Ref}
                    src={Story1}
                    onEnded={() => {
                        currentAudioRef.current = 2;

                        audioDelayRef.current = setTimeout(() => {
                            audio2Ref.current?.play().catch(() => {});
                        }, 2000);
                    }}
                />

                <audio
                    ref={audio2Ref}
                    src={Story2}
                    onEnded={() => {
                        currentAudioRef.current = 3;

                        audioDelayRef.current = setTimeout(() => {
                            audio3Ref.current?.play().catch(() => {});
                        }, 2000);
                    }}
                />

                <audio
                    ref={audio3Ref}
                    src={Story3}
                />

            <section className={`levels-page-container22 ${comingBack ? 'no-animation' : ''}`}>

                <Header 
                title='Story' title2='Story'
                link='/levels' onClick={() => setSettingsOpen(true)}
                img={pic9} icontext='Return icon'
                 img2={pic11} icontext2='settings icon'/>

                 <section className={`nolevels-number-container2 ${comingBack ? 'no-animation' : ''}`}>
                    <div className='container-level-number-nextt'>
                        <Unlockedlevel numb='1' link='/Story'/>
                    </div>
                 </section>

                <section className='container-story'>


                <section className={`row-story ${settingsOpen ? 'paused-animation' : ''}`}>
                    <section className='story-menu'>
                        <Photocontainer title='“A lost temple revealed”' img={pic17} imgalt='photo-story-1'/>
                         <Photocontainer title='“Explorer arrives”' img={pic18} imgalt='photo-story-2'/>
                         
                         <Link className='cta-position-story' to='/Howtoplayinstructions'>
                             <PrimaryctaLong title='Skip' />
                         </Link>
                    </section>

                    <section className='story-menu' to='/Howtoplayinstructions'>
                        <Photocontainer title='“The treasures are stolen”' img={pic19} imgalt='photo-story-3'/>
                         <Photocontainer title='“Thieves escape”' img={pic20} imgalt='photo-story-4'/>
                         <Link className='cta-position-story' to='/Howtoplayinstructions'>
                             <PrimaryctaLong title='Skip' />
                         </Link>
                    </section>


                    <section className='story-menu' to='/Howtoplayinstructions'>
                        <Photocontainer title='“The chase begins”' img={pic21} imgalt='photo-story-5'/>
                         <Photocontainer title='“The ruins await”' img={pic22} imgalt='photo-story-6'/>
                         <Link className='cta-position-story' to='/Howtoplayinstructions'>
                             <PrimaryctaLong title='Skip' />
                         </Link>
                    </section>

                </section>

                </section>

            </section>
        </section>
     );
}
 
export default Story;